var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item pl-3"},[(_vm.gscConfigurationsExist)?_c('a',{staticClass:"nav-link",attrs:{"href":_vm.linkGoogleGscSPA}},[_vm._v("\n    Google Search Console\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }